import React from 'react';

const GM = (props) => (
    <svg
        width="23px"
        height="21px"
        viewBox="0 0 23 21"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/GM b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-386.000000, -1125.000000)">
                <g id="Icon/OL-Copy-2" transform="translate(386.000000, 1125.000000)">
                    <path
                        d="M14.75,0 C15.1296958,0 15.443491,0.282153882 15.4931534,0.648229443 L15.5,0.75 L15.5,1.5 L20.375,1.5 C20.9963203,1.5 21.5,2.00367966 21.5,2.625 L21.5009884,9.6387167 C21.0465299,9.25678338 20.5428117,8.93157064 20.0007361,8.6739809 L20,7.5 L2,7.5 L2,16.5 L10.1612787,16.5008652 C10.2758264,17.025212 10.4491438,17.5275856 10.6739809,18.0007361 L1.625,18 C1.00367966,18 0.5,17.4963203 0.5,16.875 L0.5,2.625 C0.5,2.00367966 1.00367966,1.5 1.625,1.5 L6.5,1.5 L6.5,0.75 C6.5,0.335786438 6.83578644,0 7.25,0 C7.62969577,0 7.94349096,0.282153882 7.99315338,0.648229443 L8,0.75 L8,1.5 L14,1.5 L14,0.75 C14,0.335786438 14.3357864,0 14.75,0 Z M6.5,3 L2,3 L2,6 L20,6 L20,3 L15.5,3 L15.5,3.75 C15.5,4.16421356 15.1642136,4.5 14.75,4.5 C14.3703042,4.5 14.056509,4.21784612 14.0068466,3.85177056 L14,3.75 L14,3 L8,3 L8,3.75 C8,4.16421356 7.66421356,4.5 7.25,4.5 C6.87030423,4.5 6.55650904,4.21784612 6.50684662,3.85177056 L6.5,3.75 L6.5,3 Z"
                        id="Combined-Shape"
                        fill="#000000"
                    ></path>
                    <circle id="Oval" stroke="#000000" stroke-width="1.4" cx="17" cy="15" r="4.8"></circle>
                    <polyline
                        id="Line"
                        stroke="#000000"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        points="17 12.5 17 15.5 18.7312766 15.5"
                    ></polyline>
                </g>
            </g>
        </g>
    </svg>
);

export default GM;
